import React, { useMemo, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'
import AudioUpload from './../../compoments/AudioUpload'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';


import Loading from './../../compoments/Loading'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
    maxWidth: 700,
  },
}));

export default function AudiosCreate({ history }) {

  const rota = 'audios';
  const roleName = 'Áudios';
  const [redirect, setRedirect] = React.useState(false);
  const [name, setName] = React.useState('');
  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [audioFile, setAudioFile] = React.useState({});
  const [loading, setLoading] = React.useState(true);


  const loadData = async () => {
    setLoading(false);
  }

  useEffect(() => {
    loadData()
  }, []);

  const audioBlob = useMemo(() => {
    return audioFile && audioFile.name ? URL.createObjectURL(audioFile) : null
  }, [audioFile])

  const save = async () => {

    setLoading(true);

    const data = new FormData();

    data.append(
      'name', 
      name
    );
    
    data.append('fileVoice', audioFile);

    try {                                                               
      const res = await api.post('/v1/audios', data, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        }
      })
      setAlertTitle('')
      history.push('/' + rota)
    } catch(error) {
      setLoading(false);
      console.log('error', error)
      setAlertTitle('Erro')
      const errorLog = error.response && error.response.data && error.response.data.errors
        && error.response.data.errors[0] && error.response.data.errors[0].message || 'Erro'
      setMessage(errorLog)
    }
  }

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      <Header titleHeader={'Editar Clientes'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {loading ?  <Loading /> : 
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={`/${rota}`}>
                  {roleName}
                </Link>
                <Typography color="textPrimary">Cadastro</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                  <Grid item xs={12}>
                    <Grid item xs={6}>
                      { !(audioFile && audioFile.name)  &&
                      <AudioUpload  
                        onChange={event => { 
                          setAudioFile(event.target.files[0]) 
                        } }
                      />
                      }
                      { audioFile && audioFile.name &&
                      <figure>
                      <figcaption>{audioFile.name}</figcaption>
                        <audio
                            controls
                            src={audioBlob}>
                                Your browser does not support the
                                <code>audio</code> element.
                        </audio>
                        <DeleteForeverIcon color="secondary" onClick={()=> { 
                           loadData();
                           setAudioFile({});
                        }} />
                    </figure>
                    }
                    </Grid>
                  </Grid>
                  <Grid item xs={6} style={{marginTop: 25}}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                  </Grid>                  
                  <Grid container spacing={2} style={{marginTop: 20}}>                   
                    <Grid item xs={6}>
                      <Button
                        onClick={() => {
                          setRedirect(`/${rota}`)
                        }}
                        type="button"
                        variant="contained"
                        color="default"
                        // className={classes.submit}
                        style={{ marginRight: 30 }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={save}
                      >
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          }
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}